/* eslint-disable no-unused-vars */

const Contact = () => {
  return (
    <div>
      <h1>Contact Page</h1>
      <p>
        If you need to get ahold of me for any reason, email
        admin@suddenlife.net
      </p>
    </div>
  );
};

export default Contact;
